import router from "@/router";

export const server = {
    root: process.env.VUE_APP_SERVER_ROOT
};

const tokenError = (msg) => {
    localStorage.removeItem('user');
    router.push({path: '/login'});
    throw new Error(msg);
};

export const getJson = async res => {
    const json = await res.json();
    const {code,msg,error} = json;
   
    if(error)throw new Error(error);
    if(code === 10)return tokenError(msg);
    if(code!=500)if(code !== 0)throw new Error(msg);
 
    return json;
};

export const fetchPlus = async (url,data,options = {}) => {
    const res = await fetch(`${server.root}${url}`,{
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        ...options
    });
    return await getJson(res);
};

export const fetchFilePlus = async (url,data,options = {}) => {
    const res = await fetch(`${server.root}${url}`,{
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        ...options
    });
    // 成功返回blob，失败返回json，需要通过Content-Type判断
    const contentType = res.headers.get('Content-Type');
    if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        || contentType === 'application/pdf'
        || contentType?.startsWith('application/octet-stream')) {
        return res.blob();
    } else {
        return await getJson(res);
    }
};

export const getToken = () => {
    const str = localStorage.getItem('user');
    const user = JSON.parse(str);
    return user.token;
};

export const useToken = options => {
    const token = getToken();
    options.headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    };
    return options;
};

export const post = async (url,data,withToken = false) => {
    const options = {
        method: 'POST'
    };
    if(withToken)useToken(options);
    return await fetchPlus(url,data,options);
};

export const postFile = async (url,formData,withToken = false) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        body: formData
    };
    if (withToken) {
        const token = getToken();
        options.headers = {
            Authorization: `Bearer ${token}`
        };
    }
    const res = await fetch(`${server.root}${url}`,options);
    return await getJson(res);
};

export const put = async (url,data,withToken = false) => {
    const options = {
        method: 'PUT'
    };
    if(withToken)useToken(options);
    return await fetchPlus(url,data,options);
};

export const get = async (url,withToken = false) => {
    const options = {
        method: 'GET',
        body: null
    };
    if(withToken)useToken(options);
    return await fetchPlus(url,'',options);
};

export const downloadFile = async (url,withToken = false, fileName = 'file.xlsx') => {
    const options = {
        method: 'GET',
        body: null
    };
    if(withToken)useToken(options);
    const blob = await fetchFilePlus(url,'',options);
    const a = document.createElement('a');
    const objUrl = window.URL.createObjectURL(blob);
    a.href = objUrl;
    a.download = fileName;
    a.click();
    a.remove();
};

export const del = async (url,withToken = false) => {
    const options = {
        method: 'DELETE',
        body: null
    };
    if(withToken)useToken(options);
    return await fetchPlus(url,'',options);
};